import FullTextSearch from "./FullTextSearch"

export default  FullTextSearch;



// WEBPACK FOOTER //
// ./src/components/App/Dashboard/SubHeader/FullTextSearch/index.js